import { render, staticRenderFns } from "./_base-draggable-list.vue?vue&type=template&id=377e3147&scoped=true&"
import script from "./_base-draggable-list.vue?vue&type=script&lang=js&"
export * from "./_base-draggable-list.vue?vue&type=script&lang=js&"
import style0 from "./_base-draggable-list.vue?vue&type=style&index=0&id=377e3147&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377e3147",
  null
  
)

export default component.exports